module.exports = __webpack_public_path__ + "img/alex_journey.172f76ad.svg";